import { Environment } from '../environments';
import { HOYA_EXTERNAL_MY_ACCOUNT_URL_PROD, HOYA_EXTERNAL_WAEG_MY_ACCOUNT_URL_PPRD, 
    SEIKO_EXTERNAL_MY_ACCOUNT_URL_PROD, SEIKO_EXTERNAL_WAEG_MY_ACCOUNT_URL_PPRD } from '../const/links';

/**
 * Some configuration details unique to HOYA's branding.
 */
export const BRAND_CONFIG_HOYA = {
    name: 'hoya',
    metadata: {
        themeId: 'f94eb138-28db-42ef-ad19-c2af5a898a96',
        contactEmail: 'vc-learningsupport@hoya.com',
    },
};

/**
 * Some configuration details unique to HOYA's branding.
 */
export const BRAND_CONFIG_SEIKO = {
    name: 'seiko',
    metadata: {
        themeId: 'e332044b-0fe0-4266-89f6-f093b3e55f53',
        contactEmail: 'academy@seikovision.com',
    },
};

/**
 * All brands configured and supported by the site separated by environment. While the LXP
 * Service has its own brand creation and storage, we don't currently have a way to know
 * which brand a webapp should be using. That's what this configuration is for.
 * 
 * The `id` of the brands are expected to match the ids of brands created in the LXP Service.
 * Each brand object also contains a list of identifiers that can be used to determine what
 * brand the site should be using (the identifiers are intended to be domains or URLs
 * similar to how Nackle's Company Studio does things).
 */
export const BRAND_CONFIG_COLLECTIONS = [
    {
        environment: Environment.QA,
        brands: [
            {
                id: 'd38d3389-4bc4-4446-8b16-07fc0c4d4e74',
                ...BRAND_CONFIG_HOYA,
                brandIdentifiers: [
                    'qa.biwlearning-hoya.com',
                    'qa-internal.biwlearning-hoya.com',

                    // Move this identifier to the SEIKO config to test SEIKO brand/theme locally.
                    'http://localhost:3021',
                ],
                myAccountURL: ''
            },
            {
                id: 'e9d90284-d752-42f9-b201-35de7d1556de',
                ...BRAND_CONFIG_SEIKO,
                brandIdentifiers: [
                    'qa-seiko.biwlearning-hoya.com',
                    'qa-seiko-internal.biwlearning-hoya.com',
                    // 'http://localhost:3021',
                ],
                myAccountURL: ''
            },
            // ...
        ],
    },
    {
        environment: Environment.PPRD,
        brands: [
            {
                id: 'a8ce47a4-e159-4f45-b0fe-a2173dbae9ce',
                ...BRAND_CONFIG_HOYA,
                brandIdentifiers: [
                    'pprd.biwlearning-hoya.com',
                    'pprd-internal.biwlearning-hoya.com',
                ],
                myAccountURL: HOYA_EXTERNAL_WAEG_MY_ACCOUNT_URL_PPRD
            },
            {
                id: '98cc62e9-5407-41ee-a575-06dbce717e3d',
                ...BRAND_CONFIG_SEIKO,
                brandIdentifiers: [
                    'pprd-seiko.biwlearning-hoya.com',
                    'pprd-seiko-internal.biwlearning-hoya.com',
                ],
                myAccountURL: SEIKO_EXTERNAL_WAEG_MY_ACCOUNT_URL_PPRD
            },
            // ...
        ],
    },
    {
        environment: Environment.PROD,
        brands: [
            {
                id: 'e7bd1218-dc55-4fdb-b20e-12dd0e0d8891',
                ...BRAND_CONFIG_HOYA,
                brandIdentifiers: [
                    'prod.biwlearning-hoya.com',
                    'www.hoyavisionlearningcenter.com',
                    'hoyavisionlearningcenter.com',
                    'internal.hoyavisionlearningcenter.com',
                ],
                myAccountURL: HOYA_EXTERNAL_MY_ACCOUNT_URL_PROD
            },
            {
                id: 'dc66b781-4135-4145-95d3-6ea743f1e646',
                ...BRAND_CONFIG_SEIKO,
                brandIdentifiers: [
                    'prod-seiko.biwlearning-hoya.com',
                    'academy.seikovision.com',
                    'internal-academy.seikovision.com',
                    'www.seikovisionpro.com',
                    'seikovisionpro.com'
                ],

                myAccountURL: SEIKO_EXTERNAL_MY_ACCOUNT_URL_PROD
            },
        ],
    },
];
